import React from 'react';
const paths: Record<string, string> = {
 help: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20 M9 8a3 3 0 0 1 6 0c0 2-3 2-3 5 M12 17v1',
 today: 'M3 10 12 3 21 10 M5 9v12h14V9 M9 21v-7h6v7',
 cash: 'M3 5h18v14H3z M3 9h18 M8 15h4', salary: 'M5 3h14v18H5z M8 7h8 M8 11h8 M8 15h3',
 users: 'M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8 M2 21v-3a6 6 0 0 1 12 0v3 M16 4a4 4 0 0 1 0 8 M17 15a5 5 0 0 1 5 5',
 checklists: 'M5 3h14v18H5z M8 8l1 1 2-2 M13 8h3 M8 15l1 1 2-2 M13 15h3',
 inventory: 'M3 7l9-4 9 4v12l-9 3-9-3z M3 7l9 4 9-4 M12 11v11',
 recipes: 'M4 4h6l2 2 2-2h6v16h-6l-2 2-2-2H4z M12 6v16',
 profile: 'M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10 M3 22a9 9 0 0 1 18 0',
};
export default function NavIcon({ name }: { name: string }) { return <svg className="cs-nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path d={paths[name] || paths.recipes} strokeLinecap="round" strokeLinejoin="round" /></svg>; }
